import * as React from "react";
const SvgFiRrVirus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-virus_svg__a)">
      <path
        fill="#062147"
        d="M21.499 19.002c-.322 0-.626.066-.909.177l-1.566-1.566a9 9 0 0 0 1.323-2.264l2.402.62a1.001 1.001 0 0 0 .5-1.936l-2.373-.612c.074-.463.123-.935.123-1.42 0-.483-.049-.954-.123-1.417l2.373-.614a1 1 0 1 0-.501-1.936l-2.402.622a9 9 0 0 0-1.323-2.265l1.565-1.565c.283.11.588.177.909.177a2.5 2.5 0 0 0 2.5-2.5 2.499 2.499 0 1 0-4.998-.001c0 .322.066.627.177.909l-1.565 1.565a9 9 0 0 0-2.264-1.323l.621-2.402a1 1 0 1 0-1.937-.5l-.614 2.373A9 9 0 0 0 11.999 3c-.484 0-.955.049-1.418.123L9.968.75a1 1 0 1 0-1.937.5l.621 2.402a9 9 0 0 0-2.264 1.323L4.822 3.41c.111-.282.177-.587.177-.91A2.5 2.5 0 1 0 2.5 5.003c.322 0 .627-.066.91-.177L4.975 6.39a9 9 0 0 0-1.323 2.265L1.25 8.033a1 1 0 1 0-.501 1.936l2.373.614A9 9 0 0 0 2.999 12c0 .49.05.967.126 1.436l-2.369.595a.999.999 0 0 0 .243 1.97q.122 0 .245-.03l2.415-.606c.33.815.775 1.57 1.317 2.247L3.41 19.179a2.5 2.5 0 0 0-.909-.177A2.5 2.5 0 1 0 5 21.502c0-.322-.066-.627-.177-.91l1.566-1.565a9 9 0 0 0 2.264 1.323l-.621 2.402a1 1 0 1 0 1.937.5l.613-2.373c.463.074.935.123 1.418.123s.955-.05 1.418-.123l.614 2.373a1 1 0 0 0 1.937-.5l-.621-2.402a9 9 0 0 0 2.264-1.323l1.566 1.566a2.5 2.5 0 0 0-.177.91 2.5 2.5 0 1 0 2.5-2.5zm-9.5 0c-3.86 0-7-3.141-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m1.06-4.525a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12m3.536-1.414a1.5 1.5 0 1 1-2.121-2.12 1.5 1.5 0 0 1 2.121 2.12m-3.536-5.657a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12m-3.536 3.536a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-virus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVirus;
